import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { BreadcrumbMessages } from '../../../models/component-messages/breadcrumb-messages';

@Component({
  selector: 'app-top-table-page',
  templateUrl: './top-table-page.component.html',
  styleUrls: ['./top-table-page.component.scss']
})
export class TopTablePageComponent implements OnInit {

  windowScrolled: boolean;
  breadcrumb = new BreadcrumbMessages();

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
      this.windowScrolled = false;
    } else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
      this.windowScrolled = true;
    }
  }

  scrollToTop() {
    (function smoothScroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothScroll);
        window.scrollTo(0, 0);
      }
    })();
    return false;
  }
}
